<div class="modal-header">
  <h4 class="modal-title">Add New Database</h4>
  <button type="button" class="close" aria-label="Close" (click)="dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="dbForm">
    <!-- Platform Type -->

    <div class="row">
      <div class="col-4">
        <div class="mb-3">
          <label for="platform_type"
            >Platform Type <span class="text-danger">*</span></label
          >
          <select
            id="platform_type"
            formControlName="platform_type"
            class="form-select"
            (change)="onPlatformTypeChange()"
          >
            <option value="" selected>Select Platform</option>
            <option value="mysql">MySQL</option>
            <option value="postgres">PostgreSQL</option>
            <option value="snowflake">Snowflake</option>
          </select>
        </div>
      </div>
      <div class="col-8">
        <div *ngIf="dbForm.get('platform_type')?.value">
          <div class="mb-3">
            <label for="platform_name"
              >Database Name <span class="text-danger">*</span></label
            >
            <input
              id="platform_name"
              formControlName="platform_name"
              class="form-control"
            />
          </div>
          <div class="mb-3">
            <label for="host">Host <span class="text-danger">*</span></label>
            <input id="host" formControlName="host" class="form-control" />
          </div>
          <div class="mb-3">
            <label for="username"
              >Username <span class="text-danger">*</span></label
            >
            <input id="username" formControlName="username" class="form-control" />
          </div>
          <div class="mb-3">
            <label for="password"
              >Password <span class="text-danger">*</span></label
            >
            <div class="input-group">
            <input
              id="password"
              formControlName="password"
              [type]="showPassword ? 'text' : 'password'"
              class="form-control"
            />
          <button class="btn btn-outline-secondary" type="button" (click)="togglePasswordVisibility()">
            <i class="bi" [ngClass]="showPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
          </button></div>
          </div>
        </div>
        <!-- Snowflake Fields -->
        <div *ngIf="dbForm.get('platform_type')?.value === 'snowflake'">
          <div class="mb-3">
            <label for="role">Role</label>
            <input id="role" formControlName="role" class="form-control" />
          </div>
          <div class="mb-3">
            <label for="warehouse"
              >Warehouse <span class="text-danger">*</span></label
            >
            <input
              id="warehouse"
              formControlName="warehouse"
              class="form-control"
            />
          </div>
        </div>

        <!-- MySQL/PostgreSQL Fields -->
        <div
          *ngIf="
            dbForm.get('platform_type')?.value === 'mysql' ||
            dbForm.get('platform_type')?.value === 'postgres'
          "
        >
          <div class="mb-3">
            <label for="port">Port</label>
            <input id="port" formControlName="port" class="form-control" />
          </div>
          <div class="mb-3">
            <label for="database"
              >Database <span class="text-danger">*</span></label
            >
            <input id="database" formControlName="database" class="form-control" />
          </div>
        </div>
      </div>
    </div>


    <!-- Common Fields -->

  </form>
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-success"
    (click)="submitForm()"
    [disabled]="dbForm.invalid"
  >
    <i class="bi bi-plus-lg"></i>
    Add Database
  </button>
  <button type="button" class="btn btn-secondary" (click)="dismiss()">
    Cancel
  </button>
</div>
